<template>
	<el-container>
		<el-header>
			<Header @navData="handlePageChange" />
		</el-header>
		<router-view></router-view>
		<el-main>
			<Main v-if="toggleMain === 'main'" />
			<Fajs v-if="toggleMain === 'fajs'" />
			<Gsjj v-if="toggleMain === 'gsjj'" />
		</el-main>
		<el-footer>
			<Footer />
		</el-footer>
	</el-container>
</template>

<script>
	import Header from './views/Header.vue';
	import Main from './views/Main.vue';
	import Footer from './views/Footer.vue';
	import Gsjj from './views/Gsjj.vue';
	import Fajs from './views/Fajs.vue';
	import "@/assets/css/style.css";

	export default {
		components: {
			Header,
			Main,
			Footer,
			Gsjj,
			Fajs
		},
		name: 'index',
		data() {
			return {
				toggleMain: 'gsjj',
			};
		},
		methods: {
			handlePageChange(param) {
				this.toggleMain = param;
			}
		}
	};
</script>

<style scoped>
	h1,
	h2 {
		font-weight: normal;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}

	.el-header {
		background: url(../assets/img/header.png) no-repeat;
		background-size: 100% 100%;
	}

	.el-container {
		height: 100vh;
		background: url(../assets/img/beijing.png) no-repeat;
		background-size: 100% 100%;
		overflow: hidden;
	}

	.el-main {
		padding: 0;
		height: 80vh;
	}

	.el-footer {
		background: #070A1A;
	}
	
</style>


// WEBPACK FOOTER //
// src/components/index.vue